import React from "react";
import { Link } from "react-router-dom";
import PageHero from "../components/PageHero";
import { ArrowRight, Calendar } from "lucide-react";
import { blogPosts } from "../mock";
import useSEO from "../hooks/useSEO";

const Blog = () => {
  useSEO({
    title: "Roofing Tips & Guides for Northern Virginia | Fab Build Pro",
    description: "Roofing, storm damage, insurance claim, siding and gutter guides for Northern Virginia homeowners from Fab Build Pro, a roofing contractor in Vienna, VA.",
    crumbs: [{ name: "Blog", path: "/blog" }],
  });
  return (
    <>
      <PageHero
        title="Blog & Resources"
        subtitle="Expert roofing tips, storm & insurance guidance, and home improvement advice from the Fab Build Pro team."
      />

      <section className="bg-brand-cream py-16">
        <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogPosts.map((p) => (
            <article
              key={p.slug}
              className="group bg-white rounded-2xl overflow-hidden border border-black/5 shadow-sm hover:shadow-xl hover:-translate-y-1.5 transition-all"
            >
              <div className="h-52 overflow-hidden">
                <img
                  src={p.image}
                  alt={p.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center gap-3 text-xs mb-3">
                  <span className="bg-brand-orange/10 text-brand-orangedark font-semibold px-2.5 py-1 rounded-full">
                    {p.category}
                  </span>
                  <span className="flex items-center gap-1 text-slate-400">
                    <Calendar className="w-3.5 h-3.5" /> {p.date}
                  </span>
                </div>
                <h3 className="font-display font-bold text-brand-navy text-lg leading-snug mb-2 group-hover:text-brand-orange transition-colors">
                  {p.title}
                </h3>
                <p className="text-slate-600 text-sm leading-relaxed mb-4">
                  {p.excerpt}
                </p>
                <Link
                  to={`/blog/${p.slug}`}
                  className="inline-flex items-center gap-1.5 text-brand-orange font-semibold text-sm group-hover:gap-2.5 transition-all"
                >
                  Read More <ArrowRight className="w-4 h-4" />
                </Link>
              </div>
            </article>
          ))}
        </div>
      </section>
    </>
  );
};

export default Blog;
